"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _Spinner = _interopRequireDefault(require("@concur/nui-widgets/lib/Spinner/Spinner"));
var _styles = require("../../../styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CocpapConnectButton(_ref) {
  var onClick = _ref.onClick,
    disabled = _ref.disabled,
    renderSpinner = _ref.renderSpinner,
    italicFont = _ref.italicFont;
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    id: "listing-appcenter-flow-connect-button",
    onClick: onClick,
    style: _styles.BUTTON_STYLE,
    disabled: disabled,
    innerProps: {
      className: 'max-button-width'
    }
  }, renderSpinner ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    size: "lg",
    type: "inline",
    className: "spinner",
    visible: renderSpinner,
    message: ""
  }) : /*#__PURE__*/_react.default.createElement("span", {
    style: italicFont ? {
      fontStyle: 'italic'
    } : {}
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Connect"
  })));
}
CocpapConnectButton.propTypes = {
  disabled: _propTypes.default.bool,
  renderSpinner: _propTypes.default.bool,
  onClick: _propTypes.default.func.isRequired,
  italicFont: _propTypes.default.bool
};
var _default = exports.default = CocpapConnectButton;